module.exports = __webpack_public_path__ + "media/new/load-icon-big-b6bfdf57.svg";